module.exports = __webpack_public_path__ + "static/media/concert-0.6c54be89.jpg";